import React from 'react';

const HERO_VIDEO =
  'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/t6gmgbe6_Croquette_assembles_mid-air_202604041208.mp4';
const HERO_FALLBACK =
  'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/etsgop44_Elimina_todos_los_202604041209.png';

const HeroSection = () => {
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Video */}
      <video
        className="absolute inset-0 w-full h-full object-cover scale-105"
        src={HERO_VIDEO}
        autoPlay
        muted
        loop
        playsInline
        poster={HERO_FALLBACK}
      />

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/35 to-black/10" />

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-white/90 mb-6 fade-in" style={{ textShadow: '0 1px 8px rgba(0,0,0,0.6)' }}>
          Las Palmas de Gran Canaria · Artesanal
        </p>

        <h1
          className="font-serif font-bold text-white leading-none mb-6"
          style={{
            fontSize: 'clamp(3rem, 8vw, 6rem)',
            textShadow: '0 4px 30px rgba(0,0,0,0.6)',
          }}
        >
          El Secreto
          <br />
          es el Cuadrado
        </h1>

        <p className="text-base md:text-xl text-white/80 mb-10 max-w-lg mx-auto leading-relaxed">
          Croquetas 100% caseras, hechas a mano con ingredientes de primera
          calidad. Desde Las Palmas de Gran Canaria.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            data-testid="hero-cta-pedido"
            onClick={() => scrollTo('catalogo')}
            className="bg-[#7B1F3A] text-white px-10 py-4 text-sm font-bold uppercase tracking-widest hover:bg-[#63182E] transition-all duration-300 rounded-none"
          >
            Ver el Catálogo
          </button>
          <button
            data-testid="hero-cta-manifiesto"
            onClick={() => scrollTo('manifiesto')}
            className="border border-white/80 text-white px-10 py-4 text-sm font-bold uppercase tracking-widest hover:bg-white hover:text-[#2C2C2A] transition-all duration-300 rounded-none"
          >
            Nuestra Historia
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50">
        <span className="text-xs tracking-[0.2em] uppercase">Scroll</span>
        <div className="w-px h-10 bg-gradient-to-b from-white/50 to-transparent" />
      </div>
    </section>
  );
};

export default HeroSection;
